import I18n from 'i18n-js';
import pt from './locale/pt-BR';

I18n.fallbacks = true;

I18n.defaultLocale = 'pt';

I18n.translations = {
  pt,
};

export default I18n;
